import React from 'react';
import { ExperienceSubcategoryFaqDetails } from '../components/ExperiencesSubcategory/ExperienceSubcategoryFaqDetails';
import { ToastContainer } from 'react-toastify';

export const ExperienceSubcategoryPagesFaqPage = () => {
    return (
        <div className="main-content">
            <div className="page-content">
                <div className="container-fluid">
                    <ToastContainer position="top-right" autoClose={5000} hideProgressBar={false} />
                    <ExperienceSubcategoryFaqDetails/>
                </div>
            </div>
        </div>
    )
}